export const absolute = (value: bigint) => (value > 0 ? value : value * -1n)
